module.exports = __webpack_public_path__ + "img/animals_07_H.252a99ea.webp";